class dielineRequest extends HTMLElement {
  constructor() {
    super();

    this.values = {};

    const CLOUDINARY_URL =
      'https://res.cloudinary.com/arka/image/upload/v1636479807/components/redesign/app-dieline-request/templates';

    this.TYPE_MAP = {
      mailer: 'mailer',
      shipper: 'shipper',
      'Custom Poly Mailers': 'poly_mailers',
      'Custom Carton Boxes': 'carton_boxes',
    };

    this.LINK_MAP = {
      /* custom mailer */
      'mailer-6x6x2': `${CLOUDINARY_URL}/RELF_E_6x6x2_QE.ai`,
      'mailer-7x5.5x1.25': `${CLOUDINARY_URL}/RELF_E_7x5.5x1.25_QE.ai`,
      'mailer-10x8x4': `${CLOUDINARY_URL}/RELF_E_10x8x4.ai`,
      'mailer-12.5x10x4': `${CLOUDINARY_URL}/RELF_E_12.5x10x4_Q.ai`,
      'mailer-8x5x2': `${CLOUDINARY_URL}/RELF_E_8x5x2_QE.ai`,
      'mailer-9x8x2': `${CLOUDINARY_URL}/RELF_E_9x8x2_QE.ai`,
      'mailer-9x6x3': `${CLOUDINARY_URL}/RELF_E_9x6x3_QE.ai`,
      /* custom shipper */
      'shipper-12x12x12': `${CLOUDINARY_URL}/RSC_B_12x12x12.ai`,
      'shipper-16x12x8': `${CLOUDINARY_URL}/RSC_B_16x12x8.ai`,
      'shipper-12x12x8': `${CLOUDINARY_URL}/RSC_B_12x12x8.ai`,
      'shipper-12x6x6': `${CLOUDINARY_URL}/RSC_B_12x6x6.ai`,
      'shipper-10x10x10': `${CLOUDINARY_URL}/RSC_B_10x10x10.ai`,
      'shipper-10x8x6': `${CLOUDINARY_URL}/RSC_B_10x8x6.ai`,
      'shipper-8x8x8': `${CLOUDINARY_URL}/RSC_B_8x8x8.ai`,
      'shipper-6x6x6': `${CLOUDINARY_URL}/RSC_B_6x6x6.ai`,
      'shipper-8x6x4': `${CLOUDINARY_URL}/RSC_B_8x6x4.ai`,
      'shipper-4x4x4': `${CLOUDINARY_URL}/RSC_B_4x4x4.ai`,
      /* custom poly mailers */
      'custom-poly-mailers-7.5x12-1sided': `${CLOUDINARY_URL}/PolyMailer-F_7.5x12.ai`,
      'custom-poly-mailers-7.5x12-2sided': `${CLOUDINARY_URL}/PolyMailer-FB_7.5x12.ai`,
      'custom-poly-mailers-10x12-1sided': `${CLOUDINARY_URL}/PolyMailer-F_10x12.ai`,
      'custom-poly-mailers-10x12-2sided': `${CLOUDINARY_URL}/PolyMailer-FB_10x12.ai`,
      'custom-poly-mailers-12x14.25-1sided': `${CLOUDINARY_URL}/PolyMailer-F_14.25x12.ai`,
      'custom-poly-mailers-12x14.25-2sided': `${CLOUDINARY_URL}/PolyMailer-FB_14.25x12.ai`,
      /* custom carton boxes */
      'folding-carton-4x4x4': `${CLOUDINARY_URL}/RTE_18pt_4x4x4.ai`,
      'folding-carton-3.5x2.25x5.5': `${CLOUDINARY_URL}/RTE_18pt_3.5x2.25x5.5.ai`,
      'folding-carton-3x3x3.5': `${CLOUDINARY_URL}/RTE_18pt_3x3x3.5.ai`,
      'folding-carton-2.25x2.25x6': `${CLOUDINARY_URL}/RTE_18pt_2.25x2.25x6.ai`,
      'folding-carton-2.15625x2.15625x3.3125': `${CLOUDINARY_URL}/RTE_18pt_2.15625x2.15625x3.3125.ai`,
      /* Custom Tissue Paper */
      'tissue-paper-20x30': `https://cdn.shopify.com/s/files/1/0641/3064/6253/files/Tissue_20x30.ai?v=1684872016`,
      'tissue-paper-17x23': `https://cdn.shopify.com/s/files/1/0641/3064/6253/files/Tissue_17x23.ai?v=1684872016`,
      'tissue-paper-15x20': `https://cdn.shopify.com/s/files/1/0641/3064/6253/files/Tissue_15x20.ai?v=1684872016`,
      'tissue-paper-10x15': `https://cdn.shopify.com/s/files/1/0641/3064/6253/files/Tissue_10x15.ai?v=1684872016`,
      /* Custom Stickers */
      'custom-stickers-circle-3x3': `https://cdn.shopify.com/s/files/1/0641/3064/6253/files/custom-stickers-Circle_3x3.ai?v=1695239527`,
      'custom-stickers-circle-2x2': `https://cdn.shopify.com/s/files/1/0641/3064/6253/files/custom-stickers-Circle_2x2.ai?v=1695239588`,
      'custom-stickers-circle-1x1': `https://cdn.shopify.com/s/files/1/0641/3064/6253/files/custom-stickers-Circle_1x1.ai?v=1695239554`,
      'custom-stickers-rounded-3x3': `https://cdn.shopify.com/s/files/1/0641/3064/6253/files/custom-stickers-Rounded_3x3.ai?v=1695239546`,
      'custom-stickers-rounded-2x2': `https://cdn.shopify.com/s/files/1/0641/3064/6253/files/custom-stickers-Rounded_2x2.ai?v=1695239536`,
      'custom-stickers-rounded-1x1': `https://cdn.shopify.com/s/files/1/0641/3064/6253/files/custom-stickers-Rounded_1x1.ai?v=1695239594`,
    };

    this.values = {
      email: '',
      boxType: '',
      length: '',
      width: '',
      depth: '',
      doubleSided: false,
      isDownloaded: 0,
      size: '',
      shape: '',
    };

    this.isDownloaded = 0;

    this.forms = this.querySelectorAll('form');
    this.inputsNumber = this.querySelectorAll('input[type="number"]');
    this.inputsEmail = this.querySelectorAll('input[type="email"]');
    this.checks = this.querySelectorAll('.printing-options');
    this.buttonSubmit = this.querySelectorAll('input[type="submit"]');

    this.buttonsDownload = this.querySelectorAll('.download-btn');

    if (this.inputsEmail.length > 0) {
      this.inputsEmail.forEach((email) => {
        email.addEventListener('input', (e) => {
          if (this.validateEmail(e.target)) {
            e.target.classList.remove('ng-invalid');
          } else {
            e.target.classList.add('ng-invalid');
          }
          let container = e.target.closest('.container-options');
          this.setValues(container);
        });
      });
    }

    if (this.inputsNumber.length > 0) {
      this.inputsNumber.forEach((input) => {
        input.addEventListener('input', (e) => {
          this.validationInput(e.target);
          let container = e.target.closest('.container-options');
          this.setValues(container);
        });
      });
    }

    if (this.checks.length > 0) {
      this.checks.forEach((check) => {
        check.addEventListener('click', (e) => {
          e.preventDefault();
          if (e.target.classList.contains('.printing-options')) {
            e.target.querySelector('.check').classList.toggle('checked');
            if (
              e.target.closest('form').querySelector('.container-options .active').dataset.type == 'select' &&
              e.target.closest('form').querySelector('.container-options .active .size-label-desc')
            ) {
              let number = 1;
              if (e.target.querySelector('.check').classList.contains('checked')) {
                number = 2;
              }
              e.target.closest('form').querySelector('.container-options .active .size-label-desc').textContent =
                number + '-sided';
            }
          } else {
            e.target.closest('.printing-options').querySelector('.check').classList.toggle('checked');
            if (
              e.target.closest('form').querySelector('.container-options .active').dataset.type == 'select' &&
              e.target.closest('form').querySelector('.container-options .active .size-label-desc')
            ) {
              let number = 1;
              if (e.target.closest('.printing-options').querySelector('.check').classList.contains('checked')) {
                number = 2;
              }
              e.target.closest('form').querySelector('.container-options .active .size-label-desc').textContent =
                number + '-sided';
            }
          }
        });
      });
    }

    this.querySelectorAll('custom-dropdown').forEach((select) => {
      select.addEventListener('change', (e) => {
        let container = e.target.closest('.container-options');
        this.setValues(container);
      });
    });

    this.querySelectorAll('size-dropdown').forEach((select) => {
      select.addEventListener('change', (e) => {
        let container = e.target.closest('.container-options');
        this.setValues(container);
      });
    });

    if (this.buttonsDownload.length > 0) {
      this.buttonsDownload.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.isDownloaded = 1;
          if (e.target.closest('form').reportValidity()) {
            e.target.closest('form').querySelector('input[type="submit"]').click();
          } else {
            e.target.closest('form').reportValidity();
            e.target.closest('form').querySelector('.error').classList.remove('hidden');
          }
        });
      });
    }

    if (this.forms.length > 0) {
      this.forms.forEach((form) => {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          let container = e.target.querySelector('.container-options');
          let active = e.target.querySelector('.container-options .active');

          let type = active.dataset.type;
          let validation = this.validationInformation(active, type);

          if (e.target.reportValidity() && validation) {
            e.target.querySelector('.error').classList.add('hidden');
            this.setValues(container);
            const body = JSON.stringify(this.values);

            fetch(`${window.internalApi.baseUrl}/emails/dieline`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body,
            })
              .then((response) => response.json())
              .then((response) => {
                if (response.message == 'Request sent!') {
                  if (this.isDownloaded == 1) {
                    this.isDownloaded = 0;
                    window.open(e.target.querySelector('.download-btn').href, '_blank');
                  } else {
                    this.querySelectorAll('.form-send').forEach((form) => {
                      form.classList.add('hidden');
                    });
                    this.querySelectorAll('.message-success').forEach((message) => {
                      message.classList.remove('hidden');
                    });
                  }
                }
              })
              .catch(console.log);
          } else {
            e.target.reportValidity();
            e.target.querySelector('.error').classList.remove('hidden');
          }
        });
      });
    }

    this.initializeSwiper();
  }

  initializeSwiper() {
    const options = {
      slidesPerView: 1,
      navigation: {
        nextEl: '.swiper-navigation-next',
        prevEl: '.swiper-navigation-prev',
      },
    };

    this.swiper = new Swiper('.swiper-of-products', options);

    const cb = (swiperRef) => {
      let container = swiperRef.el.querySelector('.swiper-slide-active');
      let handle = swiperRef.el.querySelector('.swiper-slide-active').querySelector('.box-type-product-item')
        .dataset.handle;
      let optionSteps = container.closest('form').querySelector('.container-options').querySelectorAll('.swiper-slide');
      if (optionSteps.length > 0) {
        this.setOptions(optionSteps, handle, container);
      }
      if (this.inputsEmail.length > 0) {
        this.inputsEmail.forEach((email) => {
          if (this.dataset.email == '') {
            email.value = '';
            email.classList.add('ng-invalid');
          } else {
            email.value = this.dataset.email;
            email.classList.remove('ng-invalid');
          }
        });
      }

      this.swiper[0].slideTo(swiperRef.realIndex, 5000);
      this.swiper[1].slideTo(swiperRef.realIndex, 5000);
    };

    this.swiper[0].on('slideChangeTransitionEnd', cb);
    this.swiper[1].on('slideChangeTransitionEnd', cb);
  }

  validateEmail(input) {
    var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (input.value.match(validRegex)) {
      return true;
    } else {
      return false;
    }
  }

  validationInformation(active, type) {
    let val = true;
    if (type == 'size') {
      let inputs = active.querySelectorAll('input');
      if (inputs.length > 0) {
        inputs.forEach((input) => {
          if (input.value == '') {
            val = false;
          }
          if (!this.validationInput(input)) {
            val = false;
          }
        });
      }
    }
    return val;
  }

  validationInput(input) {
    let val = true;
    if (input.name == 'length') {
      val = this.setNoValid(input, 4);
    } else if (input.name == 'width') {
      val = this.setNoValid(input, 1.25);
    } else if (input.name == 'depth') {
      val = this.setNoValid(input, 1.25);
    }

    return val;
  }

  setNoValid(input, min) {
    let val = false;
    if (parseFloat(input.value) >= parseFloat(min)) {
      val = true;
      input.classList.remove('ng-invalid');
    } else {
      input.classList.add('ng-invalid');
    }

    return val;
  }

  setOptions(optionSteps, handle, container) {
    optionSteps.forEach((optionStep) => {
      if (optionStep.classList.contains(handle)) {
        optionStep.classList.remove('hidden');
        optionStep.classList.add('active');
        if (optionStep.dataset.printing != '') {
          container.closest('form').querySelector('.error').classList.add('hidden');
          container.closest('form').querySelector('.printing-options .check').classList.remove('checked');
          container.closest('form').querySelector('.printing-options').classList.remove('hidden');
          if (container.closest('form').querySelector('.size-label-desc')) {
            container.closest('form').querySelector('.size-label-desc').textContent = '1-sided';
          }
        } else {
          container.closest('form').querySelector('.printing-options').classList.add('hidden');
        }
      } else {
        optionStep.classList.add('hidden');
        optionStep.classList.remove('active');
      }
      this.resetOption(optionStep);
    });
  }

  resetOption(optionStep) {
    if (optionStep.dataset.type == 'size') {
      this.resetSize(optionStep);
    } else if (optionStep.dataset.type == 'select') {
      this.resetSelect(optionStep);
    }
  }

  resetSize(optionStep) {
    let inputs = optionStep.querySelectorAll('.form-control');
    if (inputs.length > 0) {
      inputs.forEach((input) => {
        input.value = '';
        input.classList.remove('ng-invalid');
      });
    }
  }

  resetSelect(optionStep) {
    this.values = {
      email: '',
      boxType: '',
      length: '',
      width: '',
      depth: '',
      doubleSided: false,
      isDownloaded: this.isDownloaded,
      size: '',
      shape: '',
    };
    optionStep.querySelector('#size-option-1').click();
  }

  getCircleValue(value) {
    let string = '';
    switch (value) {
      case 'circle':
        string = 'circle';
        break;
      case 'square with rounded edges':
        string = 'rounded';
        break;
      default:
        string: '';
        break;
    }

    return string;
  }

  setValues(container) {
    let showSubmit = true;
    if (!container.querySelector('.container-options .swiper-slide.active')) return;
    let type = container.querySelector('.container-options .swiper-slide.active').dataset.type;
    let name = container.querySelector('.container-options .swiper-slide.active').dataset.name;
    let handle = container.querySelector('.container-options .swiper-slide.active').dataset.handle;
    let boxType = container.querySelector('.container-options .swiper-slide.active').dataset.boxType;
    let printing = container.querySelector('.printing-options .check').classList.contains('checked');
    let string = '';
    this.values['boxType'] = name;
    this.values['doubleSided'] = printing;
    if (this.validateEmail(container.querySelector('input[type="email"]'))) {
      this.values['email'] = container.querySelector('input[type="email"]').value;
    } else {
      showSubmit = false;
    }

    if (type == 'size') {
      let inputs = container.querySelectorAll('.active input[type="number"]');
      if (inputs.length > 0) {
        inputs.forEach((input, index) => {
          if (input.value == '') {
            showSubmit = false;
          }
          let name = input.name;
          string += input.value;
          if (index < inputs.length - 1) {
            string += 'x';
          }
          this.values[`${name}`] = input.value;
        });
        this.values['size'] = string;
      }
    } else if (type == 'select') {
      let size = container.querySelector('.active size-dropdown').dataset.value;
      let string = size.split('x');
      this.values['length'] = string[0];
      this.values['width'] = string[1];
      if (string[2] != null) {
        this.values['depth'] = string[1];
      }
      this.values['size'] = size;
      if (container.querySelector('.active custom-dropdown')) {
        const circle = this.getCircleValue(
          container.querySelector('.active custom-dropdown').dataset.value.toLowerCase(),
        );
        this.values['shape'] = circle;
      } else {
        this.values['shape'] = '';
      }
    }

    const shape = this.values.shape != '' ? `-${this.values['shape'].toLowerCase()}` : ``;

    let invalid = container.querySelectorAll('.ng-invalid');
    if (invalid.length > 0 || !showSubmit) {
      this.buttonSubmit.forEach((button) => {
        button.classList.add('button-disable');
      });
    } else {
      this.buttonSubmit.forEach((button) => {
        button.classList.remove('button-disable');
      });
    }

    if (this.values['size'] != null) {
      let textPrinting = '';
      if (handle == 'custom-poly-mailers') {
        textPrinting = '-1sided';
        if (printing) {
          textPrinting = '-2sided';
        }
      }

      let index = `${boxType.toLowerCase()}${shape}-${this.values['size']}${textPrinting}`;
      let url = this.LINK_MAP[index];
      let buttonsDownload = this.querySelectorAll('.download-btn');
      if (url != null) {
        if (buttonsDownload.length > 0) {
          buttonsDownload.forEach((button) => {
            button.href = url;
            button.classList.remove('hidden');
          });
        }
      } else {
        if (buttonsDownload.length > 0) {
          buttonsDownload.forEach((button) => {
            button.classList.add('hidden');
            button.href = '#';
          });
        }
      }
    }
  }
}

if (!customElements.get('dieline-request')) {
  customElements.define('dieline-request', dielineRequest);
}
